import { Routes as AppRoutes, BrowserRouter, Route } from "react-router-dom";
import { LoginScreen } from "../LoginScreen";
import { ProtectedRoute } from "./ProtectedRoutes";
import { PublicRoute } from "./PublicRoutes";
import Callback from "../Callback";
import { Map } from "../../Pages/Map";

export function Routes() {
    return (
        <BrowserRouter>
            <AppRoutes>
                {/* PUBLIC ROUTES */}
                <Route element={<PublicRoute />}>
                    {/* <Route path="/" element={<Callback />} /> */}
                    <Route path="/" element={<Callback />} />
                    <Route path="/login" element={<LoginScreen />} />
                </Route>

                {/* PRIVATE ROUTES */}
                <Route element={<ProtectedRoute />}>
                    <Route path='/map' element={<Map />} />
                </Route>

                {/* NO MATCH ROUTES */}
                {/* <Route path="*" element={<NoMatch />} /> */}
            </AppRoutes>
        </BrowserRouter>
    );
}